import * as React from "react";
import {ColumnType} from "../list/list/ColumnType";
import {Entry, ListEntriesRequest} from "../../http/protocol";
import {TransactionEntriesService} from "../../services/TransactionEntriesService";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {EntityDataTable} from "../list/list/EntityDataTable";



let columns = [
    { property : "transactionId", name : "Transaction ID", orderBy : "transactionId", type : ColumnType.LINK, getUrl : (item : Entry) => { return "/transaction/" + item.transactionId} },
    { property : "timestamp", name : "Date", type : ColumnType.DATE},
    { property : "transactionComment", name : "Comment",renderer:(property: string, name: string, item: any) => {

        const metadata = JSON.parse(item.transactionMetadata || "{}");

        if(metadata['PAYMENT_FEE']!==undefined && item.amount!==undefined){
            if(Number(item.amount.amount!)===Number(metadata['PAYMENT_FEE'])){
                return <span>{ 'Withdrawal Fee Cancelled'}</span>
            }
            return <span>{ 'Withdrawal Cancelled'}</span>
        }
        return <span>{item.transactionComment}</span>
    }},
    { property : "accountUserId", name : "User ID", type : ColumnType.LINK, getUrl : (item : Entry) => "/user/" + item.accountUserId},
    { property : "transactionAttributes.admin_user_id", name : "Admin User ID", type : ColumnType.LINK, getUrl : (item : Entry) => { 
        const metadata = JSON.parse(item.transactionMetadata || "{}");

        return "/audit-logs/limit/50/ascending/false/orderBy/id/actorId/"+metadata!["ADMIN_USER_ID"]+"/offset/0";
    },
    renderer: (property: string, name: string, item: any) => {

        const metadata = JSON.parse(item.transactionMetadata || "{}");

        return <span>{metadata["ADMIN_USER_ID"]}</span>
    }},
    { property : "transactionAttributes.external_id", name : "External Id",
    renderer:(property: string, name: string, item: any) => {

        const metadata = JSON.parse(item.transactionMetadata || "{}");

        if(metadata['BET_ID']===undefined && metadata['EXTERNAL_ID']===undefined){
            return <span>{}</span>
        }else{
            if(metadata['BET_ID']===undefined){
                return <span>{metadata["EXTERNAL_ID"]}</span>
            }
            return <span>{"Bet Id " +metadata["BET_ID"]}</span>
        }
    }},
    { property : "amount.amount" , name : "Amount", type : ColumnType.BIG},
    { property : "transactionAttributes.casino_game_title", name : "Game Title", type : ColumnType.TEXT,
    renderer: (property: string, name: string, item: any) => {

        const metadata = JSON.parse(item.transactionMetadata || "{}");

        if(metadata["CASINO_GAME_TITLE"]===undefined || metadata["CASINO_GAME_TITLE"]===""){
            return <span>{"N/A"}</span>
        }
        return <span>{metadata["CASINO_GAME_TITLE"]}</span>
    }},
    { property : "resultingBalance.amount", name : "Resulting Balance", type : ColumnType.BIG},
    { property : "amount.currencyCode", name : "Currency"}
];
interface Props { accountId : string, service : TransactionEntriesService}

export class TransactionEntriesList extends React.Component<Props,{ pager? : any, listRequest? : ListEntriesRequest}> {

    constructor(props : Props) {
        super(props);
        this.state = { listRequest : { accountId : parseInt(props.accountId), limit : 20, offset : 0, orderBy : "id", ascending : false} };
    }
    pagerChanged(pager : PagerModel) {
        if(!this.state.listRequest) {
            return;
        }
        pager.ascending = false;
        let listRequest = ListUtils.toListRequest<ListEntriesRequest>(this.state.listRequest,pager);
        this.setState({listRequest : listRequest});
    }

    render() {
        if(!this.state.listRequest) {
            return <span/>
        }

        return <EntityDataTable
            columns={columns}
            service={this.props.service}
            listRequest={this.state.listRequest}
            onPagerChange={this.pagerChanged && this.pagerChanged.bind(this)}
            onAction={()=>undefined}
        />
    }

}